var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalanceWalletLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_2613_18985)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 69,
    r: 39,
    fill: "#00AB58"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 54.1425C46.25 51.5785 48.3285 49.5 50.8925 49.5H84.3181C86.882 49.5 88.9605 51.5785 88.9605 54.1425V82.9256C88.9605 85.4896 86.882 87.5681 84.3181 87.5681H50.8925C48.3285 87.5681 46.25 85.4896 46.25 82.9256V54.1425Z",
    fill: "#00E676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6094 64.3553C67.6094 61.7914 69.6879 59.7129 72.2518 59.7129H87.1077C89.6716 59.7129 91.7501 61.7914 91.7501 64.3553V71.7833C91.7501 74.3472 89.6716 76.4257 87.1077 76.4257H72.2518C69.6879 76.4257 67.6094 74.3472 67.6094 71.7833V64.3553Z",
    fill: "#00AB58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7605 68.3637C78.7605 70.0644 77.3818 71.4431 75.6811 71.4431C73.9803 71.4431 72.6016 70.0644 72.6016 68.3637C72.6016 66.6629 73.9803 65.2842 75.6811 65.2842C77.3818 65.2842 78.7605 66.6629 78.7605 68.3637Z",
    fill: "#00E676"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2613_18985",
    x: 0,
    y: 0,
    width: 138,
    height: 138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_2613_18985"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceWalletLight);
export default __webpack_public_path__ + "static/media/balance-wallet-light.9d0ba8010a1ff17c3a4990ea3cce3b4d.svg";
export { ForwardRef as ReactComponent };